export default "__VITE_ASSET__BEJ3xw$n__"